import { render, staticRenderFns } from "./versions.vue?vue&type=template&id=1e275da5&scoped=true&"
import script from "./versions.vue?vue&type=script&setup=true&lang=js&"
export * from "./versions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e275da5",
  null
  
)

export default component.exports